// Vendors
import classnames from 'classnames';

// Components
import * as Transitions from '../Transitions';

// Styles
import './stepper.scss';

const Stepper = ({
  steps = [],
  activeStep,
  transition = 'GrowTransition',
  onStepChange,
  onStepChanged,
  className,
}) => {
  if (!steps || !steps.length) return null;

  const Transition = Transitions[transition];

  return (
    <div className={classnames('stepper', className)}>
      {steps.map(step => {
        const { id: stepId, component: Step, data } = step;
        return (
          <Transition
            key={stepId}
            className="stepper-step"
            in={activeStep === stepId}
            onEnter={onStepChange}
            onEntered={onStepChanged}
          >
            <Step
              steps={steps}
              stepId={stepId}
              data={data}
            />
          </Transition>
        );
      })}
    </div>
  );
};

export default Stepper;
